module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodrain@3-8287646f7726eeb83a44988f77c3ca7d.png";